<template>
  <div>
    <div class="row">
      <l-map
        :zoom.sync="zoom"
        :center="center"
        style="height: 500px; width: 100%"
        ref="mapaUnidadeDeSaude"
        :options="{ zoomControl: false }"
      >
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-control-zoom position="topleft"></l-control-zoom>

        <!-- Botão para abrir modal fullscreen -->
        <l-control position="topright">
          <button
            class="leaflet-bar expand-btn"
            @click="$bvModal.show('modal-mapa-full')"
            title="Expandir"
          >
            <i class="icofont-expand"></i>
          </button>
        </l-control>

        <!-- Marcadores dos cidadão -->
        <div v-for="(item, index) in cadastros" :key="'marker-' + index">
          <div v-if="item.latitude != null || item.longitude != null">
            <l-marker
              :lat-lng="[
                item.latitude ? item.latitude : '0',
                item.longitude ? item.longitude : '0',
              ]"
              @mouseover="onMouseOverLMarker(item)"
            >
              <l-tooltip>
                <div class="tooltip-latlgn" v-html="tooltipLmarker"></div>
              </l-tooltip>
            </l-marker>
          </div>
        </div>

        <!-- Raio da equipe -->
        <template v-for="item in dadosDoMapa">
          <div :key="item.ine">
            <l-circle-marker
              :lat-lng="[item?.latitude, item?.longitude]"
              :radius="getRadiusMarker(item)"
              :color="getRadiusColor(item)"
              :fillColor="getRadiusColor(item)"
              :stroke="false"
              :fillOpacity="0.6"
            >
              <l-tooltip
                :options="{
                  permanent: true,
                  direction: 'center',
                  className: 'map-radius',
                  interactive: true,
                }"
              >
                {{ item?.cadastros_esus }}
              </l-tooltip>
              <l-popup>
                <div class="tooltip-latlgn">
                  <span> UBS: {{ item?.no_ubs }}</span>
                  <br />
                  <span>
                    CNES + INE: {{ item?.cnes }} | {{ item?.ine }} |
                    {{ item?.tipo_equipe }}</span
                  >
                  <br />
                  <span> PARÂMETRO: {{ item?.min_cad }} pessoas </span>
                  <br />
                  <span>
                    CADASTROS e-SUS: {{ item?.cadastros_esus }} pessoas
                  </span>
                  <br />
                  <span> MÁXIMO: {{ item?.max_cad }} pessoas </span>
                  <br />
                  <div class="mt-2">
                    <span
                      ><strong>ATENÇÃO!</strong>
                      <br />
                      {{ item.recomendacao_cadastro }}</span
                    >
                  </div>
                </div>
              </l-popup>
            </l-circle-marker>
          </div>
        </template>

        <!-- Modal fullscreen -->
        <b-modal
          id="modal-mapa-full"
          hide-header
          hide-footer
          modal-class="bv-modal-fullscreen"
          body-class="p-0"
          :no-close-on-esc="false"
          :no-close-on-backdrop="false"
          @shown="onModalShown"
          @hidden="onModalHidden"
        >
          <!-- Topbar flutuante -->
          <div class="modal-topbar">
            <button
              class="leaflet-bar expand-btn"
              @click="$bvModal.hide('modal-mapa-full')"
              title="Fechar"
            >
              <i class="icofont-close"></i>
            </button>
          </div>

          <!-- Segundo mapa (repete os mesmos marcadores) -->
          <l-map
            :zoom.sync="zoomFull"
            :center="centerFull"
            style="height: 100vh; width: 100%"
            ref="mapaUnidadeDeSaudeFull"
            :options="{ zoomControl: false }"
          >
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-control-zoom position="topleft"></l-control-zoom>

            <!-- Marcadores dos cidadão -->
            <div
              v-for="(item, index) in cadastros"
              :key="'marker-full-' + index"
            >
              <div v-if="item.latitude != null || item.longitude != null">
                <l-marker
                  :lat-lng="[
                    item.latitude ? item.latitude : '0',
                    item.longitude ? item.longitude : '0',
                  ]"
                  @mouseover="onMouseOverLMarker(item)"
                >
                  <l-tooltip>
                    <div class="tooltip-latlgn" v-html="tooltipLmarker"></div>
                  </l-tooltip>
                </l-marker>
              </div>
            </div>

            <!-- Raio da equipe -->
            <template v-for="item in dadosDoMapa">
              <div :key="'full-' + item.ine">
                <l-circle-marker
                  :lat-lng="[item?.latitude, item?.longitude]"
                  :radius="getRadiusMarker(item)"
                  :color="getRadiusColor(item)"
                  :fillColor="getRadiusColor(item)"
                  :stroke="false"
                  :fillOpacity="0.6"
                >
                  <l-tooltip
                    :options="{
                      permanent: true,
                      direction: 'center',
                      className: 'map-radius',
                      interactive: true,
                    }"
                  >
                    {{ item?.cadastros_esus }}
                  </l-tooltip>
                  <l-popup>
                    <div class="tooltip-latlgn">
                      <span> UBS: {{ item?.no_ubs }}</span>
                      <br />
                      <span>
                        CNES + INE: {{ item?.cnes }} | {{ item?.ine }} |
                        {{ item?.tipo_equipe }}</span
                      >
                      <br />
                      <span> PARÂMETRO: {{ item?.min_cad }} pessoas </span>
                      <br />
                      <span>
                        CADASTROS e-SUS: {{ item?.cadastros_esus }} pessoas
                      </span>
                      <br />
                      <span> MÁXIMO: {{ item?.max_cad }} pessoas </span>
                      <br />
                      <div class="mt-2">
                        <span
                          ><strong>ATENÇÃO!</strong>
                          <br />
                          {{ item.recomendacao_cadastro }}</span
                        >
                      </div>
                    </div>
                  </l-popup>
                </l-circle-marker>
              </div>
            </template>
          </l-map>
        </b-modal>
      </l-map>
    </div>
    <div class="input-map-selected">
      <div class="caption-map">
        <span class="caption-item c-orange"></span>
        <span>Cadastro e-SUS &lt; parâmetro</span>
        <span class="caption-item c-green"></span>
        <span>Cadastro e-SUS &gt;= parâmetro e &lt;= máximo</span>
        <span class="caption-item c-red"></span>
        <span>Cadastro e-SUS &gt; máximo</span>
        <!-- <span class="caption-item c-orange"></span>
              <span>Cadastros em não eSF ou eAP</span> -->
      </div>
      <div
        class="input-map-selected-content"
        v-if="
          this.$store.state.id_funcao == '1' ||
          this.$store.state.id_funcao == '2' ||
          this.$store.state.id_funcao == '7'
        "
      >
        <button
          class="btn"
          :disabled="!equipePolygon"
          @click="savePolygonData()"
        >
          Salvar localização
          <b-spinner
            small
            label="Small Spinner"
            variant="white"
            v-if="loadingBtnSubmitMap"
          ></b-spinner>
        </button>
        <!-- <input
                type="checkbox"
                v-model="checkboxEquipeDadosDoMapa"
                :disabled="disabledCheckboxEquipeDadosDoMapa"
              />
              <span>Mostrar equipe selecionada</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { coordinates } from '@/pages/PrevineBrasil/coordinates'
import mapa from '@/pages/PrevineBrasil/arquivos/mapa_ranking_regional'
import {
  LMap,
  LCircle,
  LTileLayer,
  LCircleMarker,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
  LPopup,
  LControl,
} from 'vue2-leaflet'
import { latLng, icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-draw/dist/leaflet.draw.css'
import 'leaflet-draw'
import * as Functions from './functions.js'
import utils from '@/mixins/utils'

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  components: {
    LMap,
    LCircle,
    LTileLayer,
    LMarker,
    LIcon,
    LCircleMarker,
    LTooltip,
    LControlZoom,
    LPopup,
    LControl,
  },
  mixins: [utils],
  props: {
    dadosDoMapaOriginal: {
      type: Array,
      default: () => [],
    },
    dadosDoMapa: {
      type: Array,
      default: () => [],
    },
    tabelaResultado: {
      type: Array,
      default: () => [],
    },
    equipe: {
      type: [Object, String],
      default: '',
    },
    cadastros: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      zoom: 10,
      center: latLng(-15.2, -51.31),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      drawControl: null,
      drawnItems: [],
      drawnMapItems: [],
      editedDrawnMapItems: [],
      drawnItemsLayer: null,
      loadingBtnSubmitMap: false,
      polygon: {
        borderColor: '#000',
        fillColor: '#000',
      },
      tooltipLmarker: '',
      originalMunicipioCoords: null,
      municipioPolygon: null,
      equipePolygon: null,
      showMunicipio: true,
      zoomFull: 10,
      centerFull: latLng(-15.2, -51.31),
      drawnItemsFull: null,
      drawnItemsFullEditable: null,
      municipioPolygonFull: null,
      equipePolygonFull: null,
      hasCustomControlFull: false,
      hasDrawControlFull: false,
      drawControlFull: null,
      customControlFull: null,
    }
  },
  computed: {
    cadastrosMapa() {
      return this.cadastros.map((el, index) => {
        if (el.latitude != null && el.longitude != null) {
          return {
            id: index,
            ...el,
          }
        }
      })
    },
  },
  mounted() {
    this.initMap()
  },
  watch: {
    showMunicipio(val) {
      // aplica/remover layer no inline
      this.toggleMunicipioLayer()
      // aplica/remover layer no modal
      this.toggleMunicipioLayerFull()
      // mantém os checkboxes visuais em sincronia
      this.$nextTick(() => this.syncMunicipioCheckboxes())
    },
  },
  methods: {
    async buscarDadosDoMapa() {
      setTimeout(() => {
        const cod_ibge = this.$store.state.cod_ibge
        const state = this.$store.state.cidade.split('-')[1].trim()

        // pega as coordenadas do municipio
        const countyCoordinates = mapa.find((item) => {
          return item.co_ibge === cod_ibge
        })

        // pega o zoom para o estado
        const coordinatesState = coordinates.find((item) => {
          return item.uf === state
        })
        const mapObject = this.$refs.mapaUnidadeDeSaude.mapObject

        mapObject.invalidateSize(true)
        // Faz com que não de zoom quando "semZoom" é true
        mapObject.setView(
          latLng(countyCoordinates.local[0], countyCoordinates.local[1]),
          coordinatesState.zoom + 4
        )
      }, 500)

      await this.loadLimitesMunicipio()

      if (this.equipe && this.equipe !== '') {
        await this.loadEquipePolygon()
      }
    },

    async initMap() {
      const mapObject = this.$refs.mapaUnidadeDeSaude.mapObject
      // Inicializando a camada de desenho
      this.drawnItems = new L.FeatureGroup()
      // limpa o mapa
      // this.clearMap()
      // Adiciona os layers
      mapObject.addLayer(this.drawnItems)

      if (
        this.$store.state.id_funcao == '1' ||
        this.$store.state.id_funcao == '2' ||
        this.$store.state.id_funcao == '7'
      ) {
        // Configurando as opções de desenho
        const drawControl = new L.Control.Draw({
          draw: {
            circle: false,
            rectangle: false,
            polygon: {
              shapeOptions: {
                color: this.polygon.borderColor, // Cor da borda do polígono
                fillColor: this.polygon.fillColor, // Cor do preenchimento do polígono
              },
            },
            polyline: false,
            circlemarker: false,
            marker: false,
          },
          edit: {
            featureGroup: this.drawnItems,
            remove: true,
            edit: true,
          },
        })
        mapObject.addControl(drawControl)

        mapObject.on(L.Draw.Event.CREATED, (event) => {
          const layer = event.layer
          if (this.equipe && this.equipe !== '') {
            if (this.equipePolygon) {
              alert('Só é permitido um polígono para a equipe.')
              return
            }
            this.equipePolygon = layer
            this.drawnItems.addLayer(layer)
          } else {
            alert('Selecione uma equipe!')
            this.drawnItems.addLayer(layer)
          }
        })

        // Evento editar
        mapObject.on(L.Draw.Event.EDITED, (event) => {
          const layers = event.layers
          layers.eachLayer((layer) => {
            if (layer === this.municipioPolygon) {
              layer.setLatLngs(this.originalMunicipioCoords) // Reverter mudanças no polígono do município
            }
          })
        })

        mapObject.on('draw:editstart', () => {
          if (this.showMunicipio) this.showMunicipio = false
        })

        mapObject.on('draw:editstop', () => {
          if (!this.showMunicipio) this.showMunicipio = true
        })

        // Evento deletar
        mapObject.on(L.Draw.Event.DELETED, (event) => {
          event.layers.eachLayer((layer) => {
            if (layer === this.municipioPolygon) {
              this.drawnItems.addLayer(this.municipioPolygon)
            } else if (layer === this.equipePolygon) {
              this.equipePolygon = null
              // Remove também do modal, se existir
              if (this.drawnItemsFull && this.equipePolygonFull) {
                this.drawnItemsFull.removeLayer(this.equipePolygonFull)
                this.equipePolygonFull = null
              }
            }
          })
        })

        this.addCustomControl() // Add custom control to map
      }
    },

    async loadLimitesMunicipio() {
      try {
        // Substitua pelo código real para obter o ID do município
        const response = await this.$api.get(
          `/app/municipio/${this.$store.state.cod_ibge}/limites`
        )
        if (response) {
          const geoData = JSON.parse(response.data.limite_municipal)
          if (geoData) {
            if (geoData.type == 'MultiPolygon') {
              // Se o primeiro elemento for uma matriz, é um multipolígono
              geoData.coordinates.forEach((polygon) => {
                const polygonLatLngs = polygon.map((ring) =>
                  ring.map((coord) => [coord[1], coord[0]])
                )
                const polygonLayer = L.polygon(polygonLatLngs, {
                  fillColor: 'transparent',
                  color: 'blue',
                  weight: 2,
                })
                this.municipioPolygon = polygonLayer
                this.originalMunicipioCoords = JSON.parse(
                  JSON.stringify(polygonLayer.getLatLngs())
                )
                this.drawnItems.addLayer(polygonLayer)
              })
            } else {
              // Caso contrário, é um polígono simples
              const polygonLatLngs = geoData.coordinates[0].map((coord) => [
                coord[1],
                coord[0],
              ])
              const polygonLayer = L.polygon(polygonLatLngs, {
                fillColor: 'transparent',
                color: 'blue',
                weight: 2,
              })
              this.municipioPolygon = polygonLayer
              this.originalMunicipioCoords = JSON.parse(
                JSON.stringify(polygonLayer.getLatLngs())
              )
              this.drawnItems.addLayer(polygonLayer)
            }
          }
          // const polygonLatLngs = JSON.parse(response.data.limite_municipal)
          // if (polygonLatLngs) {
          //   const polygonLayer = L.polygon(
          //     polygonLatLngs.map((coord) => [coord[1], coord[0]]),
          //     {
          //       fillColor: 'transparent',
          //       color: 'blue', // cor da borda do polígono do município
          //       weight: 2,
          //     }
          //   )
          //   this.municipioPolygon = polygonLayer
          //   this.originalMunicipioCoords = JSON.parse(
          //     JSON.stringify(polygonLayer.getLatLngs())
          //   )
          //   this.drawnItems.addLayer(polygonLayer)
          // }
        }
      } catch (error) {
        console.error('Erro ao carregar os limites do município:', error)
      }
    },

    async loadEquipePolygon() {
      try {
        // Remove existing equipe polygon if it exists
        if (this.equipePolygon) {
          this.drawnItems.removeLayer(this.equipePolygon)
          this.equipePolygon = null
        }

        let lastFourDigits = this.equipe.nu_ine.slice(-4)
        let lastTwoDigits = this.equipe.nu_ine.slice(-2)

        const polygonColor = this.intToColorHex(
          Number(lastFourDigits * lastTwoDigits)
        )
        this.polygon.borderColor = polygonColor
        this.polygon.fillColor = polygonColor
        const response = await this.$api.get(
          `/app/municipio/ubs/${this.equipe.nu_cnes}/limites`
        )
        if (response) {
          const polygonLatLngs = JSON.parse(response.data.limite_equipe)
          if (polygonLatLngs) {
            const polygonLayer = L.polygon(
              polygonLatLngs.map((coord) => [coord[0], coord[1]]),
              {
                color: this.polygon.borderColor,
                fillColor: this.polygon.fillColor,
              }
            )
            this.equipePolygon = polygonLayer
            this.drawnItems.addLayer(polygonLayer)
            const mapFull = this.$refs.mapaUnidadeDeSaudeFull?.mapObject
            if (mapFull && this.drawnItemsFull && this.drawnItemsFullEditable) {
              this.addEquipeToFull(mapFull)
            }
          }
        }
      } catch (error) {
        console.error('Erro ao carregar os limites da equipe:', error)
      }
    },

    getRadiusMarker(item) {
      return Functions.getRadius(item)
    },

    getRadiusColor(item) {
      return Functions.getRadiusColor(item)
    },

    onMouseOverLMarker(item) {
      let template = ''
      let responsavel = item.eh_resp_fam == 1 ? item : null
      if (responsavel != null) {
        let familiares = this.cadastros.filter((el) => {
          return (
            el.cfcp_resp_familia == responsavel.cfcp_resp_familia &&
            el.eh_resp_fam == 0
          )
        })

        template = `
      <b>${responsavel.no_cidadao}</b>
      <hr>
      ${familiares.map((item2) => item2.no_cidadao).join('<br>')}
      `
        this.tooltipLmarker = template
      }
    },

    async savePolygonData() {
      if (!this.equipePolygon) {
        alert('Nenhum polígono para salvar.')
        return
      }

      this.loadingBtnSubmitMap = true

      const limites = this.equipePolygon
        .getLatLngs()[0]
        .map((latlng) => [latlng.lat, latlng.lng])
      try {
        const response = await this.$api.put(`/app/municipio/ubs/limites`, {
          co_ibge: this.$store.state.cod_ibge,
          cnes: this.equipe.nu_cnes,
          limites: limites,
        })
        if (response.data.error == false) {
          this.$toast.success(response.data.message, '', {
            position: 'topRight',
          })
        } else {
          this.$toast.error(response.data.message, '', {
            position: 'topRight',
          })
        }

        const response2 = await this.$apiPublic.put(
          '/cofinanciamento-2024/ubs/localizacao',
          {
            cnes: this.equipe.nu_cnes,
          }
        )
        if (response2.data.error == true) {
          console.log('Erro ao atualizar localização')
        }
      } catch (error) {
        console.error('Erro ao salvar o polígono:', error)
      } finally {
        this.loadingBtnSubmitMap = false
      }
    },

    toggleMunicipioLayer() {
      if (this.showMunicipio) {
        this.drawnItems.addLayer(this.municipioPolygon)
      } else {
        this.drawnItems.removeLayer(this.municipioPolygon)
      }
    },

    addCustomControl() {
      const mapObject = this.$refs.mapaUnidadeDeSaude.mapObject
      const CustomControl = L.Control.extend({
        onAdd: (map) => {
          const div = L.DomUtil.create(
            'div',
            'mt-2 d-flex leaflet-control leaflet-control-custom'
          )
          div.innerHTML = `
            <input type="checkbox" id="toggleMunicipio" ${
              this.showMunicipio ? 'checked' : ''
            }
             style='margin-right: 5px'
             />
            <label for="toggleMunicipio" style='margin-bottom: 0'>Exibir limite municipal</label>
          `
          L.DomEvent.on(div, 'click', (e) => {
            e.stopPropagation()
          })

          L.DomEvent.on(div, 'change', (e) => {
            this.showMunicipio = e.target.checked
          })

          return div
        },
      })
      mapObject.addControl(new CustomControl({ position: 'topright' }))
    },

    onModalShown() {
      const inline = this.$refs.mapaUnidadeDeSaude?.mapObject
      if (inline) {
        this.centerFull = inline.getCenter()
        this.zoomFull = inline.getZoom()
      }

      this.$nextTick(async () => {
        const mapFull = this.$refs.mapaUnidadeDeSaudeFull?.mapObject
        if (!mapFull) return

        setTimeout(async () => {
          mapFull.invalidateSize(true)

          // (re)cria grupos
          if (!this.drawnItemsFull) {
            this.drawnItemsFull = new L.FeatureGroup()
            mapFull.addLayer(this.drawnItemsFull)
          } else {
            this.drawnItemsFull.clearLayers()
          }

          if (!this.drawnItemsFullEditable) {
            this.drawnItemsFullEditable = new L.FeatureGroup()
            mapFull.addLayer(this.drawnItemsFullEditable)
          } else {
            this.drawnItemsFullEditable.clearLayers()
          }

          // município (só no grupo visual)
          await this.ensureMunicipioLoaded()
          this.addMunicipioToFull(mapFull)

          // equipe (visual + editável)
          await this.ensureEquipeLoaded()
          this.addEquipeToFull(mapFull) // adiciona nos 2 grupos

          // Sempre recria os controles ao abrir (DOM do modal foi recriado)
          this.addDrawControlFull(mapFull)
          this.bindDrawEventsFull(mapFull)
          this.addCustomControlFull(mapFull)

          this.syncMunicipioCheckboxes()
        }, 0)
      })
    },

    onModalHidden() {
      const mapFull = this.$refs.mapaUnidadeDeSaudeFull?.mapObject

      // remove grupos
      if (mapFull && this.drawnItemsFull) {
        this.drawnItemsFull.clearLayers()
        mapFull.removeLayer(this.drawnItemsFull)
      }
      if (mapFull && this.drawnItemsFullEditable) {
        this.drawnItemsFullEditable.clearLayers()
        mapFull.removeLayer(this.drawnItemsFullEditable)
      }

      // remove controles
      if (mapFull && this.drawControlFull) {
        try {
          mapFull.removeControl(this.drawControlFull)
        } catch (_) {}
      }
      if (mapFull && this.customControlFull) {
        try {
          mapFull.removeControl(this.customControlFull)
        } catch (_) {}
      }

      // zera refs
      this.drawnItemsFull = null
      this.drawnItemsFullEditable = null
      this.municipioPolygonFull = null
      this.equipePolygonFull = null
      this.drawControlFull = null
      this.customControlFull = null
    },

    addMunicipioToFull(mapFull) {
      if (!this.drawnItemsFull) {
        this.drawnItemsFull = new L.FeatureGroup()
        mapFull.addLayer(this.drawnItemsFull)
      } else {
        this.drawnItemsFull.clearLayers()
      }
      this.municipioPolygonFull = null

      if (this.showMunicipio && this.municipioPolygon) {
        const latlngs = this.municipioPolygon.getLatLngs()
        const clone = L.polygon(latlngs, {
          fillColor: 'transparent',
          color: 'blue',
          weight: 2,
        })
        this.municipioPolygonFull = clone
        this.drawnItemsFull.addLayer(clone)
      }
    },

    async ensureMunicipioLoaded() {
      // garante que o polígono do município foi carregado antes de clonar
      if (!this.municipioPolygon) {
        try {
          await this.loadLimitesMunicipio()
        } catch (e) {
          console.error(
            'Não foi possível carregar limites municipais antes do modal.'
          )
        }
      }
    },

    async ensureEquipeLoaded() {
      // Carrega o polígono da equipe se ainda não existir e houver equipe selecionada
      if (!this.equipePolygon && this.equipe && this.equipe !== '') {
        try {
          await this.loadEquipePolygon()
        } catch (e) {
          console.error(
            'Não foi possível carregar limites da equipe antes do modal.'
          )
        }
      }
    },

    addEquipeToFull(mapFull) {
      if (!this.drawnItemsFull || !this.drawnItemsFullEditable) return

      // limpa cópias antigas
      if (this.equipePolygonFull) {
        this.drawnItemsFull.removeLayer(this.equipePolygonFull)
        this.drawnItemsFullEditable.removeLayer(this.equipePolygonFull)
        this.equipePolygonFull = null
      }

      if (this.equipePolygon) {
        const latlngs = this.equipePolygon.getLatLngs()
        const style = this.equipePolygon.options || {}
        const clone = L.polygon(latlngs, {
          color: style.color || this.polygon.borderColor,
          fillColor: style.fillColor || this.polygon.fillColor,
          weight: style.weight || 3,
          fillOpacity: style.fillOpacity ?? 0.2,
        })
        this.equipePolygonFull = clone

        // adiciona aos dois grupos (visual + editável)
        this.drawnItemsFull.addLayer(clone)
        this.drawnItemsFullEditable.addLayer(clone)
      }
    },

    syncMunicipioCheckboxes() {
      const cbInline = document.getElementById('toggleMunicipio')
      const cbFull = document.getElementById('toggleMunicipioFull')
      if (cbInline) cbInline.checked = this.showMunicipio
      if (cbFull) cbFull.checked = this.showMunicipio
    },

    toggleMunicipioLayerFull() {
      if (!this.drawnItemsFull) return

      if (this.showMunicipio) {
        if (this.municipioPolygonFull) {
          this.drawnItemsFull.addLayer(this.municipioPolygonFull)
        } else if (this.municipioPolygon) {
          const latlngs = this.municipioPolygon.getLatLngs()
          const clone = L.polygon(latlngs, {
            fillColor: 'transparent',
            color: 'blue',
            weight: 2,
          })
          this.municipioPolygonFull = clone
          this.drawnItemsFull.addLayer(clone)
        }
      } else {
        if (this.municipioPolygonFull) {
          this.drawnItemsFull.removeLayer(this.municipioPolygonFull)
        }
      }
    },

    addDrawControlFull(mapFull) {
      // se já existir (ex: reabertura), remove e recria
      if (this.drawControlFull) {
        try {
          mapFull.removeControl(this.drawControlFull)
        } catch (_) {}
        this.drawControlFull = null
      }

      const ctrl = new L.Control.Draw({
        draw: {
          circle: false,
          rectangle: false,
          polygon: {
            shapeOptions: {
              color: this.polygon.borderColor,
              fillColor: this.polygon.fillColor,
            },
          },
          polyline: false,
          circlemarker: false,
          marker: false,
        },
        edit: {
          featureGroup: this.drawnItemsFullEditable,
          remove: true,
          edit: true,
        },
      })

      mapFull.addControl(ctrl)
      this.drawControlFull = ctrl
    },

    bindDrawEventsFull(mapFull) {
      // CREATED — permite apenas 1 polígono da equipe
      mapFull.on(L.Draw.Event.CREATED, (ev) => {
        const layer = ev.layer

        if (this.equipe && this.equipe !== '') {
          if (this.equipePolygonFull) {
            alert('Só é permitido um polígono para a equipe.')
            return
          }
          // adiciona em ambos os grupos no modal
          this.equipePolygonFull = layer
          this.drawnItemsFull.addLayer(layer)
          this.drawnItemsFullEditable.addLayer(layer)

          // sincroniza com o mapa principal
          const latlngs = layer.getLatLngs()
          if (this.equipePolygon) {
            this.equipePolygon.setLatLngs(latlngs)
          } else {
            const style = layer.options || {}
            const cloneInline = L.polygon(latlngs, {
              color: style.color || this.polygon.borderColor,
              fillColor: style.fillColor || this.polygon.fillColor,
              weight: style.weight || 3,
              fillOpacity: style.fillOpacity ?? 0.2,
            })
            this.equipePolygon = cloneInline
            this.drawnItems.addLayer(cloneInline)
          }
        } else {
          alert('Selecione uma equipe!')
        }
      })

      // EDITED — propaga a geometria da equipe para o inline
      mapFull.on(L.Draw.Event.EDITED, (ev) => {
        ev.layers.eachLayer((layer) => {
          if (layer === this.equipePolygonFull && this.equipePolygon) {
            this.equipePolygon.setLatLngs(layer.getLatLngs())
          }
        })
      })

      // DELETED — se excluir a equipe no modal, remove no inline também
      mapFull.on(L.Draw.Event.DELETED, (ev) => {
        ev.layers.eachLayer((layer) => {
          if (layer === this.equipePolygonFull) {
            // remove do modal
            this.drawnItemsFullEditable.removeLayer(this.equipePolygonFull)
            this.drawnItemsFull.removeLayer(this.equipePolygonFull)
            this.equipePolygonFull = null
            // remove do inline
            if (this.equipePolygon) {
              this.drawnItems.removeLayer(this.equipePolygon)
              this.equipePolygon = null
            }
          }
        })
      })
    },

    addCustomControlFull(mapFull) {
      // se já existir, remove e recria
      if (this.customControlFull) {
        try {
          mapFull.removeControl(this.customControlFull)
        } catch (_) {}
        this.customControlFull = null
      }

      const vm = this
      const CustomControlFull = L.Control.extend({
        onAdd() {
          const div = L.DomUtil.create(
            'div',
            'mt-2 d-flex leaflet-control leaflet-control-custom'
          )
          div.style.top = '50px'
          div.innerHTML = `
        <input type="checkbox" id="toggleMunicipioFull"
               ${vm.showMunicipio ? 'checked' : ''}
               style="margin-right:5px" />
        <label for="toggleMunicipioFull" style="margin-bottom:0">
          Exibir limite municipal
        </label>
      `
          L.DomEvent.on(div, 'click', (e) => e.stopPropagation())
          L.DomEvent.on(div, 'change', (e) => {
            vm.showMunicipio = e.target.checked
          })

          return div
        },
      })

      const ctrl = new CustomControlFull({ position: 'topright' })
      mapFull.addControl(ctrl)
      this.customControlFull = ctrl
    },
  },
}
</script>

<style lang="scss">
.input-map-selected {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  .caption-map {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    .caption-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 5px;
      width: 15px;
      height: 15px;
      border-radius: 30px;
      &.c-yellow {
        background-color: #ff0;
      }
      &.c-green {
        background-color: green;
      }
      &.c-red {
        background-color: red;
      }
      &.c-orange {
        background-color: orange;
      }
    }
    span {
      font-size: 13px;
      text-transform: uppercase;
    }
  }
  .input-map-selected-content {
    display: flex;
    align-items: center;
    width: auto;
    gap: 15px;
    button {
      &:disabled {
        background-color: #ccc;
      }
    }
  }
}

.tooltip-latlgn {
  hr {
    margin: 0;
  }
}

.leaflet-draw-actions {
  background: none !important;
}

.expand-btn {
  display: inline-block;
  padding: 5px;
  line-height: 26px;
  font-size: 22px;
  cursor: pointer;
  border: 1px solid #ccc;
  background: #fff;
}

.bv-modal-fullscreen {
  .modal-dialog {
    max-width: 100%;
    margin: 0;
    height: 100vh;
  }

  .modal-content {
    height: 100vh;
    border: 0;
    border-radius: 0;
  }

  .modal-body {
    padding: 0;
    height: 100%;
  }
}

.modal-topbar {
  position: absolute;
  z-index: 1000;
  top: 12px;
  right: 12px;
  left: 12px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  pointer-events: none;

  .title {
    pointer-events: auto;
    background: rgba(255, 255, 255, 0.9);
    padding: 4px 10px;
    border-radius: 6px;
    font-weight: 600;
  }

  .expand-btn {
    pointer-events: auto;
  }
}
</style>
